module.exports = __webpack_public_path__ + "img/telegram.2fbdc432.svg";